export const CURRENT_SELECTION = 'current_selection'
export const NUM_PERIODS = 'num_periods'